module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Tabs', {
    attrs: {
      "animated": false
    }
  }, [_c('Tab-pane', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    staticClass: "proptab",
    style: ({
      height: (_vm.height + "px")
    }),
    attrs: {
      "label": "属性设置"
    }
  }, [_c('div', [(_vm.ispage) ? _c('div', {
    staticStyle: {
      "padding-bottom": "70px",
      "overflow": "hidden"
    }
  }, [_c('page-set', {
    attrs: {
      "pageinfo": _vm.options
    }
  })], 1) : _c('div', {
    staticStyle: {
      "padding-bottom": "70px",
      "overflow": "hidden"
    }
  }, [_c('mod-property', {
    key: _vm.attrs.type,
    attrs: {
      "options": _vm.options,
      "attrs": _vm.attrs
    }
  }), _vm._v(" "), (_vm.attrs.parent && !_vm.isformel) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("位置")]), _vm._v(" "), _c('div', {
    staticClass: "rightbox"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("X:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.attrs.left),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "left", $$v)
      },
      expression: "attrs.left"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Y:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.attrs.top),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "top", $$v)
      },
      expression: "attrs.top"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("尺寸")]), _vm._v(" "), _c('div', {
    staticClass: "rightbox"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("宽:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "min": _vm.isAbsMedia ? 20 : 0,
      "size": "large"
    },
    model: {
      value: (_vm.attrs.width),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "width", $$v)
      },
      expression: "attrs.width"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("高:")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "subinp",
    attrs: {
      "min": _vm.isAbsMedia ? 20 : 0,
      "size": "large"
    },
    model: {
      value: (_vm.attrs.height),
      callback: function($$v) {
        _vm.$set(_vm.attrs, "height", $$v)
      },
      expression: "attrs.height"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.ispage && ['media', 'mtitle', 'buttons'].findIndex(function (c) { return c == _vm.attrs.type; }) > -1) ? _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("点击事件")]), _vm._v(" "), _c('Pagelinker', {
    staticStyle: {
      "line-height": "36px"
    },
    attrs: {
      "attrs": _vm.attrs,
      "inner": _vm.isInner
    },
    model: {
      value: (_vm.attrs.childprop.modclick),
      callback: function($$v) {
        _vm.$set(_vm.attrs.childprop, "modclick", $$v)
      },
      expression: "attrs.childprop.modclick"
    }
  })], 1), _vm._v(" "), (_vm.showDetailId) ? _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("链接到")]), _vm._v(" "), _c('Select', {
    staticClass: "option-control fl",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": _vm.detail_pages.length ? false : true,
      "placeholder": _vm.detail_pages.length ? '请选择' : ("请先创建「" + _vm.detailType + "」页"),
      "size": "large",
      "placement": _vm.pagePlacement
    },
    model: {
      value: (_vm.attrs.childprop.modclick.param.pagevalue),
      callback: function($$v) {
        _vm.$set(_vm.attrs.childprop.modclick.param, "pagevalue", $$v)
      },
      expression: "attrs.childprop.modclick.param.pagevalue"
    }
  }, _vm._l((_vm.detail_pages), function(page) {
    return _c('Option', {
      key: page.id,
      attrs: {
        "value": page.id
      }
    }, [_vm._v(_vm._s(page.name))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showDetailId && _vm.attrs.childprop.modclick.param.pagevalue) ? _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("数据源")]), _vm._v(" "), _c('Input', {
    staticClass: "option-control fl special",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": true,
      "value": _vm.dataSourceAlias,
      "size": "large"
    }
  }, [_c('span', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v("已选择")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.dialogShow = true
      }
    },
    slot: "append"
  }, [_vm._v("选择")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isPageDirectShow) ? _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "option-alias"
  }, [_vm._v("跳转方式")]), _vm._v(" "), _c('RadioGroup', {
    staticStyle: {
      "line-height": "36px"
    },
    model: {
      value: (_vm.linkredirect),
      callback: function($$v) {
        _vm.linkredirect = $$v
      },
      expression: "linkredirect"
    }
  }, [_c('Poptip', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("新页面")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("保留当前页面且有返回键")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("注：目前页面路径只能最多十层")])])], 1), _vm._v(" "), _c('Poptip', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("原页面")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("关闭当前页面且无返回键")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff"
    }
  }, [_vm._v("注：页面路径无限制")])])], 1)], 1)], 1) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('Tab-pane', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    staticClass: "proptab",
    style: ({
      height: (_vm.height + "px")
    }),
    attrs: {
      "label": "样式设置"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "padding-bottom": "70px",
      "overflow": "hidden"
    }
  }, [(!_vm.nostyle) ? _c('Collapse', {
    staticClass: "set_box-container",
    staticStyle: {
      "width": "105% !important"
    },
    model: {
      value: (_vm.panelId),
      callback: function($$v) {
        _vm.panelId = $$v
      },
      expression: "panelId"
    }
  }, [_c('Panel', {
    staticClass: "set_box",
    attrs: {
      "name": "bg"
    }
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("背景设置\r\n\t\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "form-group clearFix input-reset"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("背景图片：")]), _vm._v(" "), _c('div', {
    staticClass: "fl bg-container",
    style: ({
      'background-color': _vm.glbstyle['background-color'],
      'background-image': _vm.parseBgimg,
      'background-repeat': _vm.glbstyle['background-repeat'],
      'background-position': _vm.glbstyle['background-position']
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm bg-col-sm",
    staticStyle: {
      "margin-left": "8px",
      "width": "60px"
    }
  }, [_c('div', [_c('Button', {
    staticClass: "bg-col-sm-btn",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.choosePic('bgimg')
      }
    }
  }, [_vm._v("上传")]), _vm._v(" "), _c('Button', {
    staticClass: "bg-col-sm-btn",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.glbstyle['background-image'] = 'none'
      }
    }
  }, [_vm._v("移除")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("背景颜色：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('ColorPicker2', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.glbstyle['background-color']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'background-color', $$v)
      },
      expression: "glbstyle['background-color']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix input-reset form-sort"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("背景重复：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm propbgrepeat"
  }, [_c('RadioGroup', {
    attrs: {
      "type": "button"
    },
    model: {
      value: (_vm.glbstyle['background-repeat']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'background-repeat', $$v)
      },
      expression: "glbstyle['background-repeat']"
    }
  }, [_c('Radio', {
    staticClass: "t1",
    attrs: {
      "label": "repeat"
    }
  }, [_vm._v("平铺")]), _vm._v(" "), _c('Radio', {
    staticClass: "t2",
    attrs: {
      "label": "repeat-x"
    }
  }, [_vm._v("横向平铺")]), _vm._v(" "), _c('Radio', {
    staticClass: "t3",
    attrs: {
      "label": "repeat-y"
    }
  }, [_vm._v("纵向平铺")]), _vm._v(" "), _c('Radio', {
    staticClass: "t4",
    attrs: {
      "label": "no-repeat"
    }
  }, [_vm._v("不平铺")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl label-height"
  }, [_vm._v("对齐位置：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm",
    staticStyle: {
      "width": "66px"
    }
  }, [_c('div', {
    staticClass: "position-set-block"
  }, _vm._l((_vm.bgpos), function(pos) {
    return _c('span', {
      class: {
        on: _vm.glbstyle['background-position'] == pos
      },
      on: {
        "click": function($event) {
          _vm.glbstyle['background-position'] = pos
        }
      }
    }, [_c('span', {
      staticClass: "mark"
    })])
  }), 0)])])])]), _vm._v(" "), (!_vm.ispage && !_vm.nostyle) ? _c('Panel', {
    staticClass: "set_box",
    attrs: {
      "name": "gborder"
    }
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("边框设置\r\n\t\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框样式：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "large",
      "transfer": true,
      "placement": "top"
    },
    model: {
      value: (_vm.glbstyle['border-style']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-style', $$v)
      },
      expression: "glbstyle['border-style']"
    }
  }, _vm._l((_vm.borderstyle), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框粗细：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('InputNumber', {
    attrs: {
      "size": "large",
      "max": 10,
      "min": 0
    },
    model: {
      value: (_vm.glbstyle['border-width']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-width', $$v)
      },
      expression: "glbstyle['border-width']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框颜色：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('ColorPicker2', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.glbstyle['border-color']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-color', $$v)
      },
      expression: "glbstyle['border-color']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("边框圆角：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('InputNumber', {
    attrs: {
      "size": "large",
      "min": 0
    },
    model: {
      value: (_vm.glbstyle['border-radius']),
      callback: function($$v) {
        _vm.$set(_vm.glbstyle, 'border-radius', $$v)
      },
      expression: "glbstyle['border-radius']"
    }
  })], 1)])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c(_vm.compStyle, {
    tag: "component",
    attrs: {
      "options": _vm.options,
      "attrs": _vm.attrs
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.dialogShow) ? _c('product-selector', {
    attrs: {
      "isradio": _vm.isradio,
      "attrs": _vm.attrs
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4806799e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/property.vue
// module id = 189
// module chunks = 2